import { render, staticRenderFns } from "./ScreeningProgressCard.vue?vue&type=template&id=a243810e&scoped=true&"
import script from "./ScreeningProgressCard.vue?vue&type=script&lang=js&"
export * from "./ScreeningProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProgressCard.vue?vue&type=style&index=0&id=a243810e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a243810e",
  null
  
)

export default component.exports